import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { BenefitCatalogPage } from './BenefitCatalogPage';

const searchSchema = z.object({
  search: z.string().optional(),
  publicationStatus: z.enum(['all', 'published', 'draft']).optional().default('all').catch('all'),
  reviewStatus: z.enum(['all', 'submitted_for_review']).optional().default('all').catch('all'),
  sortBy: z
    .enum(['name', 'short_name', 'created_at', 'updated_at'])
    .optional()
    .default('updated_at')
    .catch('updated_at'),
  sortOrder: z.enum(['asc', 'desc']).optional().default('desc').catch('desc'),
  cursor: z.string().optional(),
  limit: z.coerce.number().positive().int().max(100).optional().default(25).catch(25),
});

// Exported for the schema tests in index.test.tsx; the route registers the
// same schema via validateSearch.
export { searchSchema };

export const Route = createFileRoute('/_protected/admin/internal-tools/benefit-catalog/')({
  component: BenefitCatalogPage,
  validateSearch: searchSchema,
});
